import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const ContractEditor = () => {
  const navigate = useNavigate();
  const contractRef = useRef(null);
  
  const [formData, setFormData] = useState({
    contract_num: 'б/н',
    date: '2026-04-22',
    tourist: 'Копейкина Светлана Александровна',
    customer: 'Копейкин Геннадий Владимирович',
    minor: '',
    dob: '10.05.1958',
    passport: '67№4383773',
    passport_issue_date: '26.12.2025',
    passport_expiry: '26.12.2030',
    phone: '+7 950 284 68 88',
    route: 'Владивосток-Краскино-Хуньчунь-Яньцзи-Хуньчунь-Краскино-Владивосток',
    start: '18.04.2026',
    end: '22.04.2026',
    duration: '5 дней 4 ночи',
    dates_detail: 'г. Яньцзи с 18.04.2026-21.04.2026, г. Хуньчунь с 21.04.2026-22.04.2026',
    hotel: 'Отель Сиань 4* / Цзинцзян 4*, двухместный номер, раздельные кровати',
    food: 'завтрак',
    transport: 'авто-авто',
    extra: '',
    guide: 'нет',
    guide_translator: 'да',
    escort: 'нет',
    min_tourists: '5',
    visa_tourists: '2',
    price_formula: '14 900 × 2 = 29 800',
    price_text: 'двадцать девять тысяч восемьсот рублей 00 коп.',
  });

  const [previewHtml, setPreviewHtml] = useState('');
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const formatDate = (dateString) => {
    if (!dateString) return '___________';
    if (dateString.includes('.')) return dateString;
    const d = new Date(dateString);
    if (isNaN(d)) return dateString;
    return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const editableValue = (val, fallback = '___________') => {
    const text = val || fallback;
    return `<span class="editable-val">${text}</span>`;
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return '';
    const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    const d = new Date(dateString);
    if (isNaN(d)) return dateString;
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()} г.`;
  };

  useEffect(() => {
    const dateStr = formatDate(formData.date);
    const displayDate = formatDisplayDate(formData.date);
    const tourist = formData.tourist;
    const customer = formData.customer;
    const minor = formData.minor || ' ';
    const route = formData.route;
    const start = formData.start;
    const end = formData.end;
    const duration = formData.duration;
    const datesDetail = formData.dates_detail;
    const hotel = formData.hotel;
    const food = formData.food;
    const transport = formData.transport;
    const extra = formData.extra || ' ';
    const guide = formData.guide;
    const guideTranslator = formData.guide_translator;
    const escort = formData.escort;
    const minTourists = formData.min_tourists;
    const visaTourists = formData.visa_tourists;
    const priceFormula = formData.price_formula;
    const priceText = formData.price_text;
    const contractNum = formData.contract_num;
    const dob = formData.dob;
    const passport = formData.passport;
    const passportIssueDate = formData.passport_issue_date;
    const passportExpiry = formData.passport_expiry;
    const phone = formData.phone;

    const html = `
<div class="contract-title">Д О Г О В О Р № ${editableValue(contractNum)}</div>
<div class="contract-subtitle">о реализации туристского продукта</div>
<div class="contract-date-line">
  <span>${editableValue(displayDate || dateStr)}</span>
  <span>г. Владивосток</span>
</div>

<p class="clause">Индивидуальный предприниматель Лукичёва Ольга Павловна далее именуемый <b>Турагент</b>, и гр. ${editableValue(tourist)} именуемый(ая) <b>Турист (иной заказчик)</b>, с другой стороны, заключили настоящий Договор о нижеследующем:</p>

<p class="section-head">1. ПРЕДМЕТ ДОГОВОРА</p>
<p class="clause">1.1. Турагент реализует Туристу (иному заказчику) туристский продукт (комплекс услуг по перевозке и размещению, оказываемых за общую цену, и других услуг) в соответствии с положениями Договора и приложениями, являющимися неотъемлемой частью настоящего Договора, а Турист (иной заказчик) приобретает и оплачивает приобретаемый туристский продукт.</p>
<p class="clause">1.2. Термины и определения, используемые в настоящем договоре, соответствуют Федеральному закону «Об основах туристской деятельности в РФ» № 132–ФЗ в редакции от 25.12.2023 г.</p>
<p class="clause">1.3. Турагент: ИП Лукичева Ольга Павловна.<br>Адрес местонахождения: Приморский край, г. Владивосток ул. Алеутская 45а, офис 40.<br>Почтовый адрес: 690105, Приморский край, г. Владивосток ул. Русская 61г кв 82.</p>
<p class="clause">1.4. Иной заказчик (Ф.И.О.) ${editableValue(customer)}</p>
<p class="clause">1.5. Несовершеннолетний турист (Ф.И.О.) ${editableValue(minor)}</p>

<p class="section-head">2. ИНФОРМАЦИЯ О ПОТРЕБИТЕЛЬСКИХ СВОЙСТВАХ ТУРПРОДУКТА</p>
<p class="clause">2.1. Маршрут: ${editableValue(route)}</p>
<p class="clause">2.2. Прайс отправляется по запросу.</p>
<p class="clause">2.3. Дата начала путешествия ${editableValue(start)} и его окончания ${editableValue(end)}. ${editableValue(datesDetail)}</p>
<p class="clause">2.4. Общая продолжительность: ${editableValue(duration)}</p>
<p class="clause">2.5. Условия путешествия:</p>
<p class="clause-indent">2.5.1. Проживание (местонахождение средства размещения, его название, категория, если есть, по классификации страны пребывания (по независящим от туроператора причинам гостиница может быть заменена на аналогичную по классу и стоимости. Подписанием настоящего договора подтверждаю своё согласие на такую замену.)</p>
<p class="clause-indent">2.5.2. Размещение (категория номера): ${editableValue(hotel)}</p>
<p class="clause-indent">2.5.3. Питание: ${editableValue(food)}</p>
<p class="clause-indent">2.5.4. Услуги по перевозке в стране (месте) временного пребывания с указанием вида транспорта: ${editableValue(transport)}</p>
<p class="clause-indent">2.5.5. Наличие гида (экскурсовода) — ${editableValue(guide)}, гида-переводчика — ${editableValue(guideTranslator)}, сопровождающего группы — ${editableValue(escort)}</p>
<p class="clause-indent">2.5.6. Дополнительные услуги: ${editableValue(extra)}</p>
<p class="clause-indent">2.5.7. Минимальное число туристов, при котором состоится указанное путешествие ${editableValue(minTourists)}. По туристической визе ${editableValue(visaTourists)}.</p>
<p class="clause-indent">2.5.8. Дополнительный сервисный сбор: при въезде в КНР – 50 рублей, при выезде из КНР – 20 юаней (Автотур)</p>
<p class="clause-indent">2.5.9. Турагент не несёт ответственность за отмену авиарейса либо изменение времени вылета и прилёта.</p>

<p class="section-head">3. ПОРЯДОК РАСЧЕТОВ</p>
<p class="clause">3.1. Общая цена турпродукта составляет: ${editableValue(priceFormula)} (${editableValue(priceText)})</p>
<p class="clause">3.2. Оплата в размере общей цены турпродукта производится в срок не позже дня подписания настоящего договора в полном объеме по наличному или безналичному расчету в соответствии с законом РФ.</p>
<p class="clause">3.3. В случае отказа Туриста от поездки, опоздания или неявки к месту сбора группы Турагент возвращает стоимость оплаченных услуг за вычетом фактически понесенных Турагентом расходов, связанных с исполнением обязательств по данному договору.</p>
<p class="clause">3.4. Стоимость консульского сбора возврату не подлежит.</p>
<p class="clause">3.5. В случае снятия Туриста с маршрута на основании п. 4.2 настоящего договора, стоимость оставшихся дней тура Туристу не возвращается. Проезд к месту постоянного проживания Туристом оплачивается самостоятельно.</p>
<p class="clause">3.6. Если аннулирование поездки произошло по вине Турагента, то Турагент:<br>- предлагает Туристу совершить поездку по этой же программе в другие сроки;<br>- возвращает Туристу стоимость оплаченных услуг.</p>
<p class="clause">3.7. При увеличении первоначальной цены турпродукта по независящим от Турагента причинам, Турагент информирует об этом Туриста не позднее чем за 2 дня до поездки. Новая стоимость согласовывается Сторонами дополнительно. При не достижении соглашения Турист вправе отказаться от поездки и расторгнуть договор, в этом случае внесенная Туристом сумма подлежит возврату по его требованию за вычетом фактически понесенных Турагентом расходов, связанных с исполнением договора.</p>
<p class="clause">3.8. Все услуги и дополнительные расходы, не предусмотренные Договором, оплачиваются Туристом самостоятельно по месту оказания услуг и возникновению расходов. Турист самостоятельно несет транспортные и иные расходы, связанные с прибытием к указанному месту сбора, и начала тура, а также аналогичные расходы при возвращении домой по завершению поездки.</p>
<p class="clause">3.9. Туроператор не возмещает Туристу:<br>- ущерб, понесенный при возникновении форс-мажорных обстоятельств;<br>- ущерб, понесенный по вине самого Туриста.</p>
<p class="clause">3.10. Стоимость неиспользованного обслуживания и проездных документов, оплаченных Туристом (иным заказчиком) и неиспользованных по его собственной инициативе, Турагентом не возмещается.</p>

<p class="section-head">4. ПРАВА СТОРОН</p>
<p class="clause"><b>Турагент имеет право:</b></p>
<p class="clause-indent">4.1. Требовать от Туриста безусловного выполнения положений, инструктажей, полученных Туристом, и правил поведения в стране (месте) пребывания.</p>
<p class="clause-indent">4.2. Обратиться в правоохранительные органы и снять Туриста с маршрута в случае нарушения им правил поведения на транспорте, в гостинице, общественных местах, стране (месте) пребывания.</p>
<p class="clause-indent">4.3. Требовать от Туриста возмещения нанесенного им в ходе путешествия ущерба.</p>
<p class="clause-indent">4.4. Вносить изменения в ходе путешествия, если таковые возникли в связи с форс-мажорными обстоятельствами. При этом Турагент будет принимать все меры к тому, чтобы, по возможности, сохранить характер и классность оплаченных Туристом услуг.</p>
<p class="clause-indent">4.5. Отменить путешествие в случае недобора группы до минимального количества туристов. В этом случае Турагент информирует Туриста (иного заказчика) об отмене путешествия не позднее, чем за 1 день до начала тура.</p>
<p class="clause"><b>Турист (иной заказчик) при подготовке к путешествию, во время его совершения, включая транзит, имеет право:</b></p>
<p class="clause-indent">4.6. На необходимую и достоверную информацию о правилах въезда, выезда в страну временного пребывания.</p>
<p class="clause-indent">4.7. На свободу передвижения, свободный доступ к туристским ресурсам с учетом принятых в стране (месте) пребывания ограничительных мер.</p>
<p class="clause-indent">4.8. На обеспечение личной безопасности, своих потребительских прав, беспрепятственное получение неотложной медицинской помощи.</p>
<p class="clause-indent">4.9. Расторгнуть Договор в любое время и без объяснения причин, при условии оплаты Турагенту фактически понесенных им расходов, связанных с исполнением обязательств по данному договору, в том числе удержания со стороны гостиниц, транспортных компаний. Датой аннуляции поездки по инициативе Туриста (Иного заказчика) является дата поступления Турагенту письменного заявления Туриста (иного заказчика).</p>
<p class="clause-indent">4.10. Обратиться с письменным требованием о выплате страхового возмещения по договору страхования ответственности Турагента в случае невыполнения условий настоящего Договора непосредственно к организации, предоставившей Туроператору финансовое обеспечение.</p>
<p class="clause-indent">4.11. Обратиться за оказанием экстренной помощи. Под экстренной помощью понимаются действия по организации эвакуации туриста из страны временного пребывания (в том числе оплата услуг по перевозке и (или) размещению), осуществляемые объединением туроператоров в сфере выездного туризма в соответствии с действующим законодательством. Ассоциация «Объединение туроператоров в сфере выездного туризма «Турпомощь» 8 (495) 607-77-71</p>

<p class="section-head">5. ОБЯЗАННОСТИ СТОРОН</p>
<p class="clause"><b>Турагент обязан:</b></p>
<p class="clause-indent">5.1. Своевременно предоставить необходимую и достоверную информацию о потребительских свойствах туристских услуг, включая информацию о программе пребывания, об условиях безопасности туристов на маршруте и об условиях аннуляции тура.</p>
<p class="clause-indent">5.2. Оформить для Туриста необходимые для данного маршрута туристские и проездные документы.</p>
<p class="clause-indent">5.3. Своевременно подать в посольство (консульство) страны назначения документы на получение иностранных виз. При этом Турагент не несет ответственности за отказ Туристу в визе, а также всевозможные задержки в выдаче документов по вине иностранных представительств.</p>
<p class="clause-indent">5.4. Заключить договор на страхование Туриста.</p>
<p class="clause-indent">5.5. Своевременно информировать Туриста (иного заказчика) о происшедших изменениях в условиях поездки и получить письменное подтверждение (или отказ) Туриста.</p>
<p class="clause-indent">5.6. Принять необходимые меры по обеспечению безопасности полученных Турагентом в процессе оказания услуг персональных данных Туриста (иного заказчика), в том числе при их обработке, распространении и использовании.</p>
<p class="clause"><b>Турист (иной заказчик) обязан:</b></p>
<p class="clause-indent">5.7. Ознакомиться с условиями поездки, приведенными в Договоре, описанием маршрута, инструкциями по обеспечению безопасности прохождения маршрута, правилами поведения на маршруте и подтвердить свое согласие с условиями поездки своей подписью.</p>
<p class="clause-indent">5.8. Соблюдать законодательство и правовые нормы страны пребывания, уважать ее социальное устройство, обычаи, традиции, религиозные верования.</p>
<p class="clause-indent">5.9. Сохранять окружающую природную среду, бережно относиться к памятникам природы, истории и культуры в стране (месте) временного пребывания.</p>
<p class="clause-indent">5.10. Соблюдать правила въезда в страну, выезда из страны временного пребывания, а также в странах транзитного проезда.</p>
<p class="clause-indent">5.11. Соблюдать во время путешествия правила личной безопасности, сохранности своего имущества.</p>
<p class="clause-indent">5.12. Сдать Турагенту необходимые для путешествия документы не позднее 1 дня до начала поездки.</p>
<p class="clause-indent">5.13. Своевременно прибыть в пункт сбора группы, имея при себе загранпаспорт, путевку и другие документы, на необходимость которых будет указано Турагентом при инструктаже.</p>
<p class="clause-indent">5.14. Возместить стоимость понесенного убытка или ущерба в полном размере, если по вине Туриста произойдет порча, повреждение, потеря или гибель имущества гостиниц, транспортных средств, используемых во время путешествия.</p>
<p class="clause-indent">5.15. Оплатить любые расходы или штрафы, налагаемые на Турагента по вине Туриста (иного заказчика).</p>

<p class="section-head">6. ОТВЕТСТВЕННОСТЬ СТОРОН</p>
<p class="clause">6.1. Турагент несет ответственность за:<br>- неисполнение обязательств по договору;<br>- ненадлежащую информацию о туристском продукте, в том числе за причинение вреда жизни, здоровью и имуществу Туриста вследствие непредставления ему полной и достоверной информации;<br>- причинение вреда жизни, здоровью и имуществу Туриста вследствие недостатков туристского продукта.</p>
<p class="clause">6.2. Турагент не несет ответственность за:<br>- задержку или отказ в выдаче въездной визы, при этом расходы по её оформлению возврату не подлежат;<br>- действия таможенной, пограничной, миграционной и других служб, органов государственного и местного самоуправления;<br>- качество услуг, не указанных в информационном листке, которые оказаны Туристу на месте по его собственной инициативе за дополнительную плату и нанесенный ему при этом ущерб;<br>- за сохранность имущества туриста.</p>
<p class="clause">6.3. Турист (иной заказчик) несет ответственность за:<br>- точность сведений, предоставляемых для оформления выездных документов;<br>- соблюдение таможенных, пограничных, миграционных и других правил;<br>- соблюдение законов страны пребывания, а также соблюдение инструктажей по безопасному прохождению маршрута.</p>

<p class="section-head">7. ФОРС – МАЖОРНЫЕ ОБСТОЯТЕЛЬСТВА</p>
<p class="clause">7.1. Стороны освобождаются от ответственности за частичное или полное неисполнение обязательств по данному Договору, если это неисполнение явилось следствием форс-мажорных обстоятельств, возникших после заключения Договора в результате событий чрезвычайного характера, которые сторона не могла предвидеть и предотвратить разумными мерами, а именно: наводнение, пожар, землетрясение, взрыв, шторм, оседание почвы, эпидемии и иные проявления сил природы, война, военные действия, забастовки в регионе или отраслях, принятие органом государственной власти и управления правовых актов и иных событий, носящих чрезвычайный характер, повлекших за собой невозможность исполнения настоящего договора.</p>

<p class="section-head">8. ПОРЯДОК И СРОКИ ПРЕДЪЯВЛЕНИЯ ВЗАИМНЫХ ПРЕТЕНЗИЙ</p>
<p class="clause">8.1. Претензии по качеству туристского обслуживания предъявляются Туристом (иным заказчиком) Туроператору в письменной форме в течение 20 дней с момента окончания действия настоящего Договора и подлежат рассмотрению в течение 10 дней после получения претензии.</p>
<p class="clause">8.2. Соответственно, Турист обязан возместить ущерб, нанесенный Турагенту в те же сроки, при условии предъявления претензии Турагентом в 20-дневный срок с момента окончания действия Договора.</p>
<p class="clause">8.3. При возникновении у Туриста претензий к качеству туристского обслуживания необходимо решать все конфликтные ситуации с руководителем группы, а в его отсутствии с представителями принимающей стороны. В случае невозможности их разрешения, составляется соответствующий акт (протокол), который подписывается туристом и руководителем группы, либо представителем принимающей стороны.</p>
<p class="clause">8.4. Претензии подаются в письменной форме с приложением всех необходимых документов (акт, медицинская справка, счет и т.д.).</p>
<p class="clause">8.5. Все споры и разногласия, которые могут возникнуть из настоящего Договора или в связи с ним, будут по возможности решаться путем переговоров между Сторонами. В случае не достижения договоренности, споры разрешаются в судебном порядке.</p>

<p class="section-head">9. ПОРЯДОК И СРОКИ ПРЕДЪЯВЛЕНИЯ ТУРИСТОМ ТРЕБОВАНИЙ К ОРГАНИЗАЦИИ, ПРЕДСТАВИВШЕЙ ТУРОПЕРАТОРУ ФИНАНСОВОЕ ОБЕСПЕЧЕНИЕ</p>
<p class="clause">9.1. Страховщик обязан выплатить страховое возмещение по договору страхования ответственности Турагента по письменному требованию Туриста при наступлении страхового случая.</p>
<p class="clause">9.2. Основанием для выплаты страхового возмещения по договору страхования ответственности Турагента является факт установления обязанности туроператора возместить Туристу (иному заказчику) реальный ущерб, возникший в результате неисполнения или ненадлежащего исполнения Туроператором обязательств по договору о реализации туристского продукта, если это является существенным нарушением условий такого договора.</p>
<p class="clause">9.3. Существенным нарушением условий договора признается нарушение, которое влечет для Туриста такой ущерб, что он в значительной степени лишается того, на что был вправе рассчитывать при заключении договора.</p>
<p class="clause">9.4. Иск о возмещении реального ущерба может быть предъявлен Туристом Турагенту либо Турагенту и Страховщику совместно.</p>

<p class="section-head">10. УСЛОВИЯ СТРАХОВАНИЯ</p>
<p class="clause">10.1. Страхование жизни и здоровья во время путешествия является добровольным и может быть оформлено по желанию туриста за дополнительную плату. Для туристов, выезжающих по визе!</p>
<p class="clause">10.2. При наступлении события, имеющего признаки страхового случая, обратиться к турагенту можно по номеру телефона WhatsApp +7 914 657 96 07, +7 996 426 96 52, электронная почта для пересылки документов maximum-olga@mail.ru</p>

<p class="section-head">11. ИЗМЕНЕНИЕ И РАСТОРЖЕНИЕ ДОГОВОРА</p>
<p class="clause">11.1. Каждая из сторон вправе потребовать изменения или расторжения Договора в связи с существенными изменениями обстоятельств, из которых исходили при заключении договора, а именно:<br>- ухудшение условий путешествия;<br>- изменение сроков совершения путешествия;<br>- недобор указанного в настоящем договоре минимального количества туристов;<br>- непредвиденный рост транспортных тарифов;<br>- невозможность совершения Туристом поездки по независящим от него обстоятельствам.</p>
<p class="clause">11.2. Порядок и условия изменения и расторжения договора определяются Гражданским кодексом РФ.</p>
<p class="clause">11.3. Любые изменения к настоящему Договору действительны в случае, если они совершены в письменной форме, подписаны Сторонами и оформлены приложением к нему.</p>

<p class="section-head">12. СРОК ДЕЙСТВИЯ ДОГОВОРА</p>
<p class="clause">12.1. Настоящий Договор действует со дня его подписания до окончания туристской поездки.</p>
<p class="clause">12.2. Договор составлен в 2-х экземплярах, каждый из которых имеет одинаковую юридическую силу.</p>

<p class="section-head">13. ОСОБЫЕ УСЛОВИЯ</p>
<p class="clause">13.1. Иной заказчик, заключивший настоящий договор в интересах Туриста(ов), обязан под роспись передать Туристу всю документацию, полученную от Туроператора, содержание инструктажей, проведённых с ним представителем Турагента.</p>

<p class="section-head">14. ПРОЧИЕ УСЛОВИЯ</p>
<p class="clause">14.1. Турист (иной заказчик) с памяткой по стране, инструктажами по безопасному прохождению маршрута, условиями аннуляции тура, условиями страхования, правилами таможенного и пограничного контроля, правилами перевозки багажа и другой необходимой информацией ознакомлен.</p>
<p class="clause">14.2. Турист (иной заказчик) предупрежден о возможности изменения сроков въезда и выезда из страны пребывания, а также о последствиях выезда из мест размещения в случае, если выезд произведен по инициативе Туриста.</p>
<p class="clause">14.3. Турист согласен на передачу и обработку его персональных данных, в том числе биометрических, третьим лицам, связанную с исполнением обязательств по настоящему договору.</p>

<!-- SIGNATURE TABLE -->
<table class="signature-table">
  <tr>
    <td class="sig-cell">
      <div class="sig-title">Турагент</div>
      <div class="sig-content">
        <div>Индивидуальный Предприниматель</div>
        <div>Лукичёва Ольга Павловна</div>
        <div>ИНН 251701033652</div>
        <div>ОГРН 324253600092340</div>
        <div>Расчетный счёт 40802810700006819608</div>
        <div>АО «ТБанк»</div>
        <div>Юридический адрес 650105 г. Владивосток ул. Русская 61г кв 82</div>
        <div>Фактический адрес офиса г. Владивосток ул. Алеутская 45а каб.40</div>
        <div>туристическая компания «Максимум»</div>
        <div>Телефон: +79146579607</div>
        <div>e-mail: maximum-olga@mail.ru</div>
        <br>
        <div class="stamp-wrapper">
          <img src="/stamp.png" class="stamp-img" alt="Печать" onerror="this.style.display='none'" />
          <div>ИП Лукичёва О.П. ________________</div>
        </div>
        <br><br><br><br><br>
      </div>
    </td>
    <td class="sig-cell">
      <div class="sig-title">Турист (иной заказчик)</div>
      <div class="sig-content">
        <div>Дата рождения: ${editableValue(dob)}</div>
        <div>Паспорт: ${editableValue(passport)}</div>
        <div>Дата выдачи: ${editableValue(passportIssueDate)}</div>
        <div>Срок действия: ${editableValue(passportExpiry)}</div>
        <div>Тел.: ${editableValue(phone)}</div>
        <br><br>
        <div>${editableValue(tourist)} ________________</div>
      </div>
    </td>
  </tr>
</table>
`;

    setPreviewHtml(html);
  }, [formData]);

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPDF = async () => {
    if (!contractRef.current) return;
    
    setIsGeneratingPDF(true);
    
    try {
      const contractClone = contractRef.current.cloneNode(true);
      
      contractClone.style.background = 'white';
      contractClone.style.boxShadow = 'none';
      contractClone.style.width = '210mm';
      contractClone.style.padding = '20mm 20mm 20mm 25mm';
      contractClone.style.boxSizing = 'border-box';
      
      const editableVals = contractClone.querySelectorAll('.editable-val');
      editableVals.forEach(el => {
        el.style.background = 'transparent';
        el.style.borderBottom = 'none';
        el.style.textDecoration = 'none';
        el.style.padding = '0';
      });
      
      contractClone.style.position = 'absolute';
      contractClone.style.left = '-9999px';
      contractClone.style.top = '0';
      document.body.appendChild(contractClone);
      
      await new Promise(resolve => setTimeout(resolve, 200));
      
      const totalHeight = contractClone.scrollHeight;

      // A4 at 96dpi ≈ 1123px tall
      // We reserve top + bottom margins (15mm each ≈ 57px) so content never touches edges
      const a4HeightPx = 1123;
      const marginPx = 57; // ~15mm at 96dpi
      const pageContentHeightPx = a4HeightPx - marginPx * 2; // ~1009px of usable content per page
      
      const pages = [];
      let currentOffset = 0;
      let pageNumber = 0;
      
      while (currentOffset < totalHeight) {
        const remaining = totalHeight - currentOffset;
        
        // Find the best break point within the usable content height
        const elements = contractClone.querySelectorAll('p, .section-head, .signature-table, .clause, .clause-indent');
        let bestBreakPoint = currentOffset + Math.min(pageContentHeightPx, remaining);
        
        for (const el of elements) {
          const elBottom = el.offsetTop + el.offsetHeight;
          if (elBottom > currentOffset && elBottom <= currentOffset + pageContentHeightPx) {
            bestBreakPoint = elBottom;
          }
        }
        
        const captureHeight = Math.min(bestBreakPoint - currentOffset, remaining);
        
        const canvas = await html2canvas(contractClone, {
          scale: 3,
          backgroundColor: '#ffffff',
          logging: false,
          useCORS: true,
          allowTaint: false,
          y: currentOffset,
          height: captureHeight,
          windowHeight: captureHeight
        });
        
        pages.push(canvas);
        currentOffset = bestBreakPoint;
        pageNumber++;
        
        if (pageNumber > 30) break;
      }
      
      document.body.removeChild(contractClone);
      
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      
      const pdfWidth = pdf.internal.pageSize.getWidth();   // 210mm
      const marginMM = 15; // top margin for each page in the PDF
      
      for (let i = 0; i < pages.length; i++) {
        if (i > 0) pdf.addPage();
        
        const canvas = pages[i];
        const imgData = canvas.toDataURL('image/png');
        
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const scale = pdfWidth / imgWidth;
        const scaledHeight = imgHeight * scale;
        
        // Place image with top margin so content never starts at the very edge
        pdf.addImage(imgData, 'PNG', 0, marginMM, pdfWidth, scaledHeight);
      }
      
      const fileName = `Договор_${formData.tourist.replace(/\s+/g, '_')}_${formData.date}.pdf`;
      pdf.save(fileName);
      
    } catch (error) {
      console.error('Ошибка при создании PDF:', error);
      alert('Не удалось создать PDF. Попробуйте еще раз.');
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const handleGoBack = () => {
    navigate('/admin');
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .contract.printing-for-pdf {
          background: white !important;
          box-shadow: none !important;
        }

        .contract.printing-for-pdf .editable-val {
          background: transparent !important;
          border-bottom: 1px solid #666 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        @media print {
          .contract p,
          .contract .clause,
          .contract .clause-indent,
          .contract .section-head {
            page-break-inside: avoid;
          }
          
          .contract .section-head {
            page-break-after: avoid;
          }
          
          .contract .signature-table {
            page-break-inside: avoid;
          }
          
          .contract {
            page-break-after: auto;
          }
        }

        .contract-editor-container {
          display: flex;
          min-height: 100vh;
          font-family: Arial, sans-serif;
          background-color: #f0f2f5;
        }
        
        .contract-editor-sidebar {
          width: 360px;
          min-width: 360px;
          background-color: white;
          border-right: 1px solid #e0e0e0;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        
        .sidebar-header {
          background: #1a56db;
          color: white;
          padding: 16px 20px;
          font-size: 15px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        
        .sidebar-header small {
          display: block;
          font-weight: normal;
          font-size: 12px;
          opacity: 0.85;
          margin-top: 2px;
        }
        
        .back-btn {
          background: rgba(255,255,255,0.2);
          color: white;
          border: 1px solid rgba(255,255,255,0.3);
          padding: 6px 12px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 500;
          transition: all 0.2s;
        }
        
        .back-btn:hover {
          background: rgba(255,255,255,0.3);
        }
        
        .sidebar-body {
          flex: 1;
          overflow-y: auto;
          padding: 16px;
        }
        
        .field-group {
          margin-bottom: 16px;
        }
        
        .field-group label {
          display: block;
          font-size: 11px;
          font-weight: 600;
          color: #555;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 5px;
        }
        
        .field-group input,
        .field-group textarea,
        .field-group select {
          width: 100%;
          padding: 8px 10px;
          border: 1px solid #d0d0d0;
          border-radius: 6px;
          font-size: 13px;
          font-family: Arial, sans-serif;
          transition: border-color 0.2s;
          background: #fafafa;
        }
        
        .field-group input:focus,
        .field-group textarea:focus {
          outline: none;
          border-color: #1a56db;
          background: white;
        }
        
        .field-group textarea {
          resize: vertical;
          min-height: 56px;
        }
        
        .field-row {
          display: flex;
          gap: 10px;
        }
        
        .field-row .field-group {
          flex: 1;
        }
        
        .section-title {
          font-size: 11px;
          font-weight: 700;
          color: #1a56db;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          padding: 10px 0 6px;
          border-top: 1px solid #eee;
          margin-top: 10px;
        }
        
        .section-title:first-of-type {
          border-top: none;
          margin-top: 0;
          padding-top: 0;
        }
        
        .action-buttons {
          display: flex;
          gap: 10px;
          padding: 12px 16px;
          border-top: 1px solid #e0e0e0;
        }
        
        .btn {
          flex: 1;
          padding: 12px;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          text-align: center;
          transition: all 0.2s;
        }
        
        .btn-print {
          background: #1a56db;
          color: white;
        }
        
        .btn-print:hover {
          background: #1648c0;
        }
        
        .btn-pdf {
          background: #dc2626;
          color: white;
        }
        
        .btn-pdf:hover {
          background: #b91c1c;
        }
        
        .btn-pdf:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        .preview-area {
          flex: 1;
          overflow-y: auto;
          padding: 30px;
          background: #e8eaf0;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .preview-label {
          font-size: 12px;
          color: #666;
          margin-bottom: 12px;
          text-align: center;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .contract {
          background: white;
          width: 210mm;
          min-height: 297mm;
          padding: 15mm 20mm 15mm 25mm;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          font-family: "Times New Roman", Times, serif;
          font-size: 11pt;
          line-height: 1.4;
          color: #000;
          position: relative;
        }
        
        .contract-title {
          text-align: center;
          font-weight: bold;
          font-size: 14pt;
          margin-bottom: 4px;
        }
        
        .contract-subtitle {
          text-align: center;
          margin-bottom: 16px;
          font-size: 12pt;
        }
        
        .contract-date-line {
          display: flex;
          justify-content: space-between;
          margin-bottom: 16px;
          font-size: 11pt;
        }
        
        .contract p {
          margin-bottom: 6px;
          text-align: justify;
        }
        
        .contract .section-head {
          font-weight: bold;
          font-size: 11pt;
          margin-top: 12px;
          margin-bottom: 6px;
          text-align: center;
        }
        
        .contract .clause {
          margin-bottom: 4px;
          text-align: justify;
          padding-left: 0;
        }
        
        .contract .clause-indent {
          margin-bottom: 4px;
          text-align: justify;
          padding-left: 20px;
        }
        
        .editable-val {
          background: #fff8e1;
          border-bottom: 1px dashed #f59e0b;
          padding: 0 2px;
          border-radius: 2px;
        }
        
        .signature-table {
          width: 100%;
          margin-top: 25px;
          border-collapse: collapse;
          border: 2px solid black !important;
          box-sizing: border-box;
        }

        .signature-table td {
          width: 50%;
          vertical-align: top;
          padding: 10px;
          border: 2px solid black !important;
          box-sizing: border-box;
        }

        @media print {
          .signature-table {
            border: 2px solid black !important;
          }
          .signature-table td {
            border: 2px solid black !important;
          }
        }
        
        .sig-cell {
          font-size: 10pt;
        }
        
        .sig-title {
          font-weight: bold;
          margin-bottom: 10px;
          text-align: center;
          font-size: 11pt;
        }
        
        .sig-content {
          line-height: 1.5;
        }
        
        .stamp-wrapper {
          position: relative;
          display: inline-block;
        }
        
        .stamp-img {
          width: 110px;
          height: 100px;
          position: absolute;
          left: 100px;
          top: -25px;
          opacity: 0.8;
          pointer-events: none;
          z-index: 1000;
          mix-blend-mode: multiply;
        }
        
        @media print {
          body { 
            background: white; 
            margin: 0;
            padding: 0;
          }
          .contract-editor-sidebar { display: none !important; }
          .preview-area { 
            padding: 0 !important; 
            background: white !important; 
            display: block; 
          }
          .preview-label { display: none !important; }
          .contract {
            width: 100% !important;
            box-shadow: none !important;
            margin: 0 !important;
            padding: 10mm 15mm 10mm 20mm !important;
            font-size: 10pt !important;
            min-height: auto !important;
          }
          .editable-val {
            background: transparent !important;
            border-bottom: 1px solid #ccc !important;
          }
          .stamp-img {
            opacity: 0.8 !important;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .signature-table {
            border: 1px solid black !important;
          }
          .signature-table td {
            border: 1px solid black !important;
          }
          @page { 
            size: A4; 
            margin: 0;
          }
        }
      `}</style>

      <div className="contract-editor-container">
        {/* SIDEBAR EDITOR */}
        <div className="contract-editor-sidebar">
          <div className="sidebar-header">
            <div>
              ✏️ Редактор договора
              <small>Максимум Тур — реализация туристского продукта</small>
            </div>
            <button className="back-btn" onClick={handleGoBack}>
              ← Назад
            </button>
          </div>
          
          <div className="sidebar-body">
            <div className="section-title">📋 Основные данные</div>
            
            <div className="field-group">
              <label>Номер договора</label>
              <input type="text" value={formData.contract_num} onChange={(e) => handleInputChange('contract_num', e.target.value)} />
            </div>
            
            <div className="field-group">
              <label>Дата договора</label>
              <input type="date" value={formData.date} onChange={(e) => handleInputChange('date', e.target.value)} />
            </div>
            
            <div className="section-title">👤 Турист / Заказчик</div>
            
            <div className="field-group">
              <label>ФИО туриста</label>
              <input type="text" value={formData.tourist} onChange={(e) => handleInputChange('tourist', e.target.value)} />
            </div>
            
            <div className="field-group">
              <label>ФИО иного заказчика (п.1.4)</label>
              <input type="text" value={formData.customer} onChange={(e) => handleInputChange('customer', e.target.value)} />
            </div>
            
            <div className="field-group">
              <label>Несовершеннолетний турист</label>
              <input type="text" value={formData.minor} onChange={(e) => handleInputChange('minor', e.target.value)} placeholder="не указан" />
            </div>
            
            <div className="field-row">
              <div className="field-group">
                <label>Дата рождения</label>
                <input type="text" value={formData.dob} onChange={(e) => handleInputChange('dob', e.target.value)} placeholder="ДД.ММ.ГГГГ" />
              </div>
              <div className="field-group">
                <label>Телефон</label>
                <input type="text" value={formData.phone} onChange={(e) => handleInputChange('phone', e.target.value)} />
              </div>
            </div>
            
            <div className="field-group">
              <label>Паспорт (серия и номер)</label>
              <input type="text" value={formData.passport} onChange={(e) => handleInputChange('passport', e.target.value)} placeholder="12№345678" />
            </div>
            
            <div className="field-row">
              <div className="field-group">
                <label>Дата выдачи паспорта</label>
                <input type="text" value={formData.passport_issue_date} onChange={(e) => handleInputChange('passport_issue_date', e.target.value)} placeholder="ДД.ММ.ГГГГ" />
              </div>
              <div className="field-group">
                <label>Срок действия</label>
                <input type="text" value={formData.passport_expiry} onChange={(e) => handleInputChange('passport_expiry', e.target.value)} placeholder="ДД.ММ.ГГГГ" />
              </div>
            </div>
            
            <div className="section-title">✈️ Маршрут и даты</div>
            
            <div className="field-group">
              <label>Маршрут</label>
              <textarea value={formData.route} onChange={(e) => handleInputChange('route', e.target.value)} />
            </div>
            
            <div className="field-row">
              <div className="field-group">
                <label>Начало путешествия</label>
                <input type="text" value={formData.start} onChange={(e) => handleInputChange('start', e.target.value)} />
              </div>
              <div className="field-group">
                <label>Окончание</label>
                <input type="text" value={formData.end} onChange={(e) => handleInputChange('end', e.target.value)} />
              </div>
            </div>
            
            <div className="field-group">
              <label>Продолжительность</label>
              <input type="text" value={formData.duration} onChange={(e) => handleInputChange('duration', e.target.value)} />
            </div>
            
            <div className="field-group">
              <label>Дополнительно о датах</label>
              <textarea value={formData.dates_detail} onChange={(e) => handleInputChange('dates_detail', e.target.value)} />
            </div>
            
            <div className="section-title">🏨 Условия путешествия</div>
            
            <div className="field-group">
              <label>Проживание</label>
              <textarea value={formData.hotel} onChange={(e) => handleInputChange('hotel', e.target.value)} />
            </div>
            
            <div className="field-row">
              <div className="field-group">
                <label>Питание</label>
                <input type="text" value={formData.food} onChange={(e) => handleInputChange('food', e.target.value)} />
              </div>
              <div className="field-group">
                <label>Транспорт</label>
                <input type="text" value={formData.transport} onChange={(e) => handleInputChange('transport', e.target.value)} />
              </div>
            </div>
            
            <div className="field-row">
              <div className="field-group">
                <label>Гид (экскурсовод)</label>
                <select value={formData.guide} onChange={(e) => handleInputChange('guide', e.target.value)}>
                  <option value="да">да</option>
                  <option value="нет">нет</option>
                </select>
              </div>
              <div className="field-group">
                <label>Гид-переводчик</label>
                <select value={formData.guide_translator} onChange={(e) => handleInputChange('guide_translator', e.target.value)}>
                  <option value="да">да</option>
                  <option value="нет">нет</option>
                </select>
              </div>
              <div className="field-group">
                <label>Сопровождающий</label>
                <select value={formData.escort} onChange={(e) => handleInputChange('escort', e.target.value)}>
                  <option value="да">да</option>
                  <option value="нет">нет</option>
                </select>
              </div>
            </div>
            
            <div className="field-row">
              <div className="field-group">
                <label>Мин. число туристов</label>
                <input type="text" value={formData.min_tourists} onChange={(e) => handleInputChange('min_tourists', e.target.value)} />
              </div>
              <div className="field-group">
                <label>По тур. визе</label>
                <input type="text" value={formData.visa_tourists} onChange={(e) => handleInputChange('visa_tourists', e.target.value)} />
              </div>
            </div>
            
            <div className="field-group">
              <label>Дополнительные услуги</label>
              <input type="text" value={formData.extra} onChange={(e) => handleInputChange('extra', e.target.value)} placeholder="не указаны" />
            </div>
            
            <div className="section-title">💰 Цена</div>
            
            <div className="field-group">
              <label>Стоимость (формула / сумма)</label>
              <input type="text" value={formData.price_formula} onChange={(e) => handleInputChange('price_formula', e.target.value)} />
            </div>
            
            <div className="field-group">
              <label>Сумма прописью</label>
              <input type="text" value={formData.price_text} onChange={(e) => handleInputChange('price_text', e.target.value)} />
            </div>
          </div>
          
          <div className="action-buttons">
            <button className="btn btn-print" onClick={handlePrint}>
              🖨️ Печать
            </button>
            <button className="btn btn-pdf" onClick={handleDownloadPDF} disabled={isGeneratingPDF}>
              {isGeneratingPDF ? '⏳ Создание...' : '📄 Скачать PDF'}
            </button>
          </div>
        </div>
        
        {/* PREVIEW AREA */}
        <div className="preview-area">
          <div className="preview-label">📄 Предпросмотр договора (реальный размер А4)</div>
          <div 
            className="contract" 
            ref={contractRef}
            dangerouslySetInnerHTML={{ __html: previewHtml }}
          />
        </div>
      </div>
    </>
  );
};

export default ContractEditor;